import Instance from "./Instance";

// Admin product storefront management (OrderProduct.md §7).
// Controls what appears on the public ordering site. Requires staff JWT.

// Publish / unpublish a product. Only published products appear publicly.
export const setProductPublished = async (id, isPublished) => {
    try {
        const response = await Instance.patch(`/api/v1/setProductPublished/${id}`, {
            isPublished
        });
        return response.data;
    } catch (error) {
        console.error("Error setting product published state:", error);
        throw error;
    }
};

// Upload a single product image (multipart/form-data, field name "image").
// Allowed: JPEG/PNG/WebP, max 10 MB. Do NOT set Content-Type — the browser
// adds the multipart boundary itself. Stored in object storage; the returned
// data.image / data.images[] hold absolute URLs.
export const uploadProductImage = async (id, file) => {
    try {
        const fd = new FormData();
        fd.append("image", file);
        const response = await Instance.post(`/api/v1/uploadProductImage/${id}`, fd, {
            headers: { "Content-Type": "multipart/form-data" }
        });
        return response.data;
    } catch (error) {
        console.error("Error uploading product image:", error);
        throw error;
    }
};

// Remove one product image. Pass the entry exactly as it appears in images[] —
// an absolute URL, or a legacy "/uploads/products/x.jpg" path for old uploads.
export const removeProductImage = async (id, image) => {
    try {
        const response = await Instance.patch(`/api/v1/removeProductImage/${id}`, {
            image
        });
        return response.data;
    } catch (error) {
        console.error("Error removing product image:", error);
        throw error;
    }
};
